import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Lock, Zap, Users } from 'lucide-react';
export function OpeningLead() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="min-h-screen flex flex-col justify-center items-center px-6 pt-24 pb-10 max-w-[720px] mx-auto text-center md:text-left" data-id="element-225">
      <motion.div variants={container} initial="hidden" animate="show" className="space-y-6 w-full" data-id="element-226">
        {/* Badge */}
        <motion.div variants={item} className="text-center" data-id="element-227">
          <motion.div animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-flex items-center gap-2 bg-[var(--accent-soft)] border border-[var(--accent)]/30 text-[var(--accent)] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-1" data-id="element-228">
            <Zap className="w-3 h-3 fill-current" data-id="element-229" />
            Precio de lanzamiento — Solo por tiempo limitado
          </motion.div>
        </motion.div>

        {/* Headline */}
        <motion.div variants={item} className="space-y-3 text-center" data-id="element-230">
          <p className="text-[var(--accent)] text-sm font-bold tracking-[0.2em] uppercase" data-id="element-231">
            Para quien lleva meses cargando una pregunta que da vergüenza decir
            en voz alta
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[var(--text-heading)] leading-[1.1]" data-id="element-232">
            "Si Dios me ama...
            <br data-id="element-233" />
            <span className="text-[var(--accent)] italic" data-id="element-234">
              ¿por qué siento que me está destruyendo?"
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-[var(--text-muted)] font-serif italic mt-2" data-id="element-235">
            La respuesta que la iglesia no te dio, que la autoayuda no puede
            darte, y que tu alma lleva meses esperando.
          </p>
        </motion.div>

        {/* Book image */}
        <motion.div variants={item} className="w-full py-6 flex justify-center" data-id="element-236">
          <div className="relative group cursor-pointer" onClick={scrollToCTA} data-id="element-237">
            <div className="absolute inset-0 bg-[var(--accent)] blur-[80px] opacity-20 rounded-full group-hover:opacity-35 transition-opacity duration-700 scale-110" data-id="element-238"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qqSQtgi38348gBy1iPXcuM/cover_3.png" alt="¿Por Qué a Mí, Dios?" className="relative z-10 w-56 md:w-72 rounded-lg shadow-[0_0_40px_rgba(139,105,20,0.2)] border border-[var(--accent)]/25 hover:scale-105 transition-all duration-500" data-id="element-239" />
          </div>
        </motion.div>

        {/* Hook copy */}
        <motion.div variants={item} className="space-y-4 text-lg md:text-xl text-[var(--text-primary)] leading-relaxed font-light" data-id="element-240">
          <p className="font-semibold text-[var(--text-heading)]" data-id="element-241">
            Anoche no dormiste bien.
          </p>
          <p data-id="element-242">No fue el café. No fue el teléfono.</p>
          <p data-id="element-243">
            Fue esa pregunta que llevas semanas, meses, quizás años cargando
            como una piedra en el pecho:
          </p>

          <div className="pl-6 border-l-2 border-[var(--accent)] py-2 my-4" data-id="element-244">
            <p className="font-serif italic text-[var(--text-heading)] text-xl" data-id="element-245">
              "¿Por qué a mí? ¿Por qué ahora? ¿Por qué después de tanto
              esfuerzo, tanta fe, tanto sacrificio... sigo aquí, en el piso, sin
              entender nada?"
            </p>
          </div>

          <p data-id="element-246">
            Y lo más doloroso no es la pérdida en sí. No es el divorcio, la
            quiebra, la traición, la enfermedad, o el sueño que se derrumbó.
          </p>
          <p data-id="element-247">
            <strong className="text-[var(--text-heading)]" data-id="element-248">
              Lo más doloroso es el silencio de Dios.
            </strong>
          </p>
          <p data-id="element-249">
            Oraste. Ayunaste. Creíste. Y el cielo pareció cerrarse como una
            puerta de acero. Sin respuesta. Sin señal. Sin nada.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div variants={item} className="pt-6 text-center space-y-3" data-id="element-250">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(139,105,20,0)', '0 0 30px 8px rgba(139,105,20,0.25)', '0 0 0 0 rgba(139,105,20,0)']
        }} transition={{
          boxShadow: {
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full md:w-auto px-12 py-5 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#faf7f2] font-extrabold text-lg rounded-lg shadow-lg overflow-hidden group mx-auto flex items-center justify-center gap-3" data-id="element-251">
            <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-252" />
            <BookOpen className="w-5 h-5 relative z-10" data-id="element-253" />
            <span className="relative z-10 uppercase tracking-wide" data-id="element-254">
              → SÍ, QUIERO ENTENDER MI PROCESO
            </span>
          </motion.button>

          <div className="flex items-center justify-center gap-2 text-sm text-[var(--text-muted)]" data-id="element-255">
            <Users className="w-4 h-4 text-[var(--accent)]" data-id="element-256" />
            <span data-id="element-257">✅ +1,240 personas ya encontraron respuestas</span>
          </div>

          <p className="text-xs text-[var(--text-muted)] tracking-wider uppercase flex items-center justify-center gap-3" data-id="element-258">
            <Lock className="w-3 h-3" data-id="element-259" />
            Acceso inmediato · Garantía 7 días · Sin riesgo
          </p>
        </motion.div>
      </motion.div>
    </section>;
}